<template>
  <div>
    <event-creator
      v-if="user[0].role == 'superadmin'"
      v-on:refresh="getTrainings()"
      class="mb-4"
    />
    <event-details v-on:refresh="getTraining(current_event.id)" />
    <FullCalendar
      id="calendar"
      v-if="ready"
      ref="fullCalendar"
      :options="calendarOptions"
    />
  </div>
</template>

<script>
import "@fullcalendar/core/vdom"; // solves problem with Vite
import EventCreator from "@/components/modals/EventCreator";
import EventDetails from "@/components/modals/EventDetails";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    FullCalendar,
    EventDetails,
    EventCreator,
  },
  data() {
    return {
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
        selectable: true,
        initialView: "timeGridWeek",
        dateClick: this.handleDateClick,
        themeSystem: "bootstrap",
        eventClick: this.eventclick,
        locale: "ru",
        allDaySlot: false,
        eventColor: "#dc3545",
        eventBackgroundColor: "rgb(33, 37, 41)",
        eventTextColor: "#ffffff",
        headerToolbar: {
          start: "title",
          center: "timeGridWeek,timeGridDay",
        },

        events: [],
      },
      trainings: [],
      ready: true,
    };
  },
  async mounted() {
    await this.getTrainings();
  },
  computed: {
    ...mapState(["current_event", "user"]),
  },
  methods: {
    ...mapActions(["setCurrentEvent", "logOutUser"]),
    eventclick: function (info) {
      this.getTraining(info.event.id);
      this.openModal();
    },
    getTraining(training_id) {
      this.fetchTraining(training_id);
    },
    async fetchTraining(trainingId) {
      let response = await this.$api.schedule.getTraining(trainingId);
      this.setCurrentEvent(response.data.Message.Training);
    },
    openModal() {
      this.$root.$emit("bv::show::modal", "modal-event-view");
    },
    handleDateClick: function () {
      let calendarApi = this.$refs.fullCalendar.getApi(); // from the ref="..."
      calendarApi.changeView("timeGridDay");
    },
    async getTrainings() {
      this.ready = false;
      let response = await this.$api.schedule.getSchedule();
      this.trainings = response.data;

      this.eventGenerator();
      this.ready = true;
    },
    eventGenerator() {
      this.trainings.forEach((training) => {
        this.calendarOptions.events.push({
          title: training.name,
          date: training.time,
          id: training.id,
          start: training.time,
          end: new Date(training.time).setHours(
            new Date(training.time).getHours() + 1,
          ),
        });
      });
    },
  },
};
</script>

<style scoped>
#calendar {
  max-height: 900px;
  margin: auto;
}
</style>
